import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ServicesHero from '../components/services/ServicesHero';
import ServiceCategories from '../components/services/ServiceCategories';
import OngoingManagement from '../components/services/OngoingManagement';
import BusinessAgencySolutions from '../components/services/BusinessAgencySolutions';
import ServicesHowItWorks from '../components/services/ServicesHowItWorks';
import ServicesFAQ from '../components/services/ServicesFAQ';
import FinalCTA from '../components/home/FinalCTA';
import '../styles/home.css';

const Services = () => {
  const location = useLocation();

  useEffect(() => {
    const title = 'Services | ManagedSite.net';
    const description =
      'Website management, design, email, hosting, security, and technical support for businesses and agencies. Start with a Digital Review.';
    document.title = title;
    const updateMeta = (selector, attr, value) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute(attr, value);
    };
    updateMeta('meta[name="description"]', 'content', description);
    updateMeta('meta[property="og:title"]', 'content', title);
    updateMeta('meta[property="og:description"]', 'content', description);
    updateMeta('meta[property="twitter:title"]', 'content', title);
    updateMeta('meta[property="twitter:description"]', 'content', description);
    const hash = location.hash.replace('#', '');
    if (hash) {
      requestAnimationFrame(() => {
        document.getElementById(hash)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      return;
    }
    window.scrollTo(0, 0);
  }, [location.hash]);

  return (
    <div className="home-page w-full">
      <ServicesHero />
      <ServiceCategories />
      <OngoingManagement />
      <BusinessAgencySolutions />
      <ServicesHowItWorks />
      <ServicesFAQ />
      <FinalCTA />
    </div>
  );
};

export default Services;
